import { useEffect, useRef } from 'react'

import type { ToolCallResolver } from './UiActionContext'
import { useUiActionRunner } from './useUiActionRunner'

export function useToolCallResolver(resolver: ToolCallResolver): void {
  const { registerToolCallResolver } = useUiActionRunner()

  const latest = useRef(resolver)
  latest.current = resolver

  const stable = useRef<ToolCallResolver>()
  if (!stable.current) {
    stable.current = {
      approve: source => latest.current.approve(source),
      reject: (source, reason) => latest.current.reject(source, reason),
    }
  }

  useEffect(() => registerToolCallResolver(stable.current as ToolCallResolver), [registerToolCallResolver])
}
